import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import useStyles from "./styles";

export default function WarningFlexAdvice({ text, isCustom }) {
  const { container, iconStyle, message, customContainer, customMessage } =
    useStyles();
  return (
    <div className={isCustom ? customContainer : container}>
      <FontAwesomeIcon icon="exclamation-triangle" className={iconStyle} />
      <Typography
        className={isCustom ? customMessage : message}
        variant="body2"
      >
        {text}
      </Typography>
    </div>
  );
}

WarningFlexAdvice.defaultProps = {
  text: "",
  isCustom: false,
};

WarningFlexAdvice.propTypes = {
  text: PropTypes.string,
  isCustom: PropTypes.bool,
};
